<template>
  <div>
    <a style="color: black" @click="back">
      <a-icon type="left" class="hover-font-active" />
      <span style="font-weight: 700; font-size: 20px; margin-left: 20px"
        >支付方式设置</span
      >
    </a>

    <a-form-model labelAlign="left" ref="ruleForm" :model="form" :rules="rules">
      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 3 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="收款方式名称"
        prop="configName"
      >
        <a-input
          :maxLength="200"
          v-model="form.configName"
          placeholder="请输入"
        ></a-input>
      </a-form-model-item>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item
            :colon="false"
            :labelCol="{ lg: { span: 9 } }"
            :wrapperCol="{ lg: { span: 15 } }"
            label="收款对接渠道"
            :style="{ display: 'inline-block', width: 'calc(100% - 12px)' }"
            prop="payChannelId"
          >
            <a-select
              style="margin-left: 6px"
              placeholder="请选择"
              v-model="form.payChannelId"
              @change="changePayChannel"
            >
              <a-select-option
                v-for="item in payChannelList"
                :key="item.payChannelId"
                :value="item.payChannelId"
              >
                {{ item.payChannelName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item
            :colon="false"
            label=" "
            :labelCol="{ lg: { span: 0 } }"
            :wrapperCol="{ lg: { span: 14 } }"
            class="paralleling"
            :style="{ display: 'inline-block', width: 'calc(100% - 12px)' }"
            prop="payMethodId"
          >
            <a-select
              placeholder="请选择"
              v-model="form.payMethodId"
              @change="changePayMethod"
            >
              <a-select-option
                v-for="item in payMethodList"
                :key="item.payMethodId"
                :value="item.payMethodId"
              >
                {{ item.payMethodName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 3 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="支付App下载链接"
        prop="downloadUrl"
      >
        <a-input v-model="form.downloadUrl" placeholder="请输入"></a-input>
      </a-form-model-item>

      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 3 } }"
        :wrapperCol="{ lg: { span: 15 } }"
        label="程序对接配置"
        prop="configJson"
        class="configJson"
      >
        <a-textarea
          style="
            display: inline-block;
            width: 49%;
            margin-right: 2%;
            height: 400px;
          "
          @change="changeConfigJson"
          v-model="form.configJson"
          placeholder="请输入"
          :auto-size="{ minRows: 10 }"
        />
        <a-textarea
          style="display: inline-block; width: 49%; height: 400px"
          @change="changeConfigJson"
          v-model="form.configJsonChinese"
          :disabled="true"
          placeholder="请输入"
          :auto-size="{ minRows: 10 }"
        />
        <div style="color: #ff5c00">
          注意：此配置项需技术支持确认，否则可能无法正常支付
        </div>
      </a-form-model-item>

      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 3 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="客户端显示顺序"
        prop="ordinal"
      >
        <a-row>
          <a-col :span="4">
            <a-input-number
              v-model="form.ordinal"
              :min="1"
              :max="100"
              style="marginleft: 16px"
            />
          </a-col>
        </a-row>
      </a-form-model-item>

      <a-form-model-item
        style="margin-left: 11px"
        v-if="!isAdd"
        :colon="false"
        :labelCol="{ lg: { span: 3 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="适用课程分类"
        prop="classifyId"
      >
        <a-checkbox-group
          style="margin-left: -9px"
          @change="changeClassifyId"
          v-model="form.classifyId"
          :options="plainOptions"
        />
      </a-form-model-item>

      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 3 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label=" "
      >
        <a-button type="primary" class="save" @click="save('ruleForm')"
          >保存</a-button
        >
        <a-button type="primary" class="test" @click="test" v-if="!isAdd"
          >测试下单</a-button
        >
      </a-form-model-item>
    </a-form-model>
    <a-modal :closable="false" :visible="testVisible">
      <template slot="footer">
        <a-button key="back" @click="copy('testCopy')"> 复制详情 </a-button>
        <a-button key="submit" type="primary" @click="confirm"> 确定 </a-button>
      </template>
      <div v-show="show">
        <div>
          <img
            src="/icon/success.png"
            alt=""
            style="width: 20px; margin-bottom: 3px"
          />
          <span class="title1">调用支付下单成功</span>
        </div>
        <p class="title2">
          程序对接设置正确，成功调用支付接口。
          <span id="testCopy" class="testCopy">{{
            this.successMessageDetail
          }}</span>
        </p>
      </div>
      <div v-show="!show">
        <div>
          <img src="/icon/error.png" alt="" class="img" />
          <span class="title1">调用支付下单失败</span>
        </div>
        <p class="title2">
          可能由于对接配置有误，无法成功调用支付通道接口。异常信息是：
          <span>{{ this.msg }}</span>
          <span id="testCopy" class="testCopy">{{
            this.errorMessageDetail
          }}</span>
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import finOrder from '../../api/finOrder'

const plainOptions = [
  { label: '个性化', value: '1' },
  { label: '社团课', value: '2' },
  { label: '托管班', value: '3' },
]
export default {
  data() {
    return {
      form: {
        configName: '',
        payChannelId: '',
        payMethodId: '',
        downloadUrl: '',
        configJson: '',
        ordinal: 50,
        classifyId: [], //课程
        configJsonChinese: '',
      },
      rules: {
        configName: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 200,
            message: '请输入少于200字符的收款方式名称',
            trigger: 'blur',
          },
        ],
        payChannelId: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        downloadUrl: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
        configJson: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
        ordinal: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        classifyId: [
          {
            required: false,
            message: '请选择',
            trigger: 'blur',
          },
        ],
      },
      testVisible: false, //测试下单弹框
      plainOptions,
      payChannelList: [], //收款对接渠道列表
      payMethodList: [],
      isAdd: true,
      oldMetId: '', //上一个支付方法的id
      oldConfigJson: '',
      successMessageDetail: '',
      errorMessageDetail: '', //下单复制详情
      show: false,
      msg: '', //简略信息
    }
  },
  created() {
    if (this.$route.query.record) {
      let a = JSON.parse(this.$route.query.record)
      this.isAdd = false
      this.getPayConfigCurrent(a.id)
    } else {
      this.getPayChannel('')
    }
  },
  methods: {
    //返回
    back() {
      // this.$router.push('/paySetting')
      this.$router.push({ name: 'paySetting' })
      this.$parent.getPayConfigListV2()
    },
    //修改配置
    changeConfigJson(e) {
      // console.log('e', e.path[0]._value)
      this.oldConfigJson = e.path[0]._value
    },
    //切换课程
    changeClassifyId(e) {
      // console.log('e', e)
      this.form.classifyId = e
    },
    //程序配置数据回显
    getConfigJson(data) {
      // console.log('data', data)
      finOrder.getConfigJson(data).then((res) => {
        // console.log('getConfigJsonres', res)
        if (!res.data) {
          return
        }
        // let a = res.data.replace(/,/g, ',\n')
        // let b = a.replace('{', '{\n')
        // let c = b.replace('}', '\n}')
        // console.log('c', c)
        // this.form.configJson = JSON.parse(JSON.stringify(c))
        // this.$nextTick()
        this.$set(this.form, 'configJson', res.data)
        this.form.configJson = res.data
        this.form.configJsonChinese = res.doc
        this.oldConfigJson = res.data
        // console.log('this.form', this.form)
      })
    },
    //数据回显
    getPayConfigCurrent(id) {
      finOrder.getPayConfigCurrent({ id: id }).then((res) => {
        // console.log('getPayConfigCurrentres', res)
        this.form = res.data
        if (this.form.classifyId) {
          this.form.classifyId = res.data.classifyId.map((item) => {
            return item.toString()
          })
        }
        this.oldMetId = res.data.payMethodId
        this.getPayChannel(this.form.payChannelId)
        this.getConfigJson({
          id: this.form.id,
          tMetId: this.form.payMethodId,
          oldMetId: this.oldMetId,
          setJson: this.oldConfigJson,
        })
      })
    },
    //保存按钮
    save(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          // console.log('form', this.form)
          if (this.isAdd) {
            //新增保存
            delete this.form.classifyId
            finOrder.addPaymentSettings(this.form).then((res) => {
              this.$message.success('新增成功')
              this.back()
            })
          } else {
            console.log(' this.form.classifyId', this.form.classifyId == null)
            this.form.classifyId =
              this.form.classifyId == null ? '' : this.form.classifyId
            finOrder
              .updatePayConfig({
                ...this.form,
              })
              .then((res) => {
                this.$message.success('修改成功')
                this.back()
              })
          }
        }
      })
    },
    //收款对接渠道2下拉框
    changePayMethod() {
      if (this.isAdd) {
        finOrder
          .getPayConfigEcho({
            targetPayMethodId: this.form.payMethodId,
            oldPayMethodId: '',
            paySettingString: '',
          })
          .then((res) => {
            // let a = res.data.replace(/,/g, ',\n')
            // let b = a.replace('{', '{\n')
            // let c = b.replace('}', '\n}')
            this.form.configJson = res.data
            this.form.configJsonChinese = res.doc
            this.oldConfigJson = res.data
          })
      } else {
        this.getConfigJson({
          id: this.form.id,
          tMetId: this.form.payMethodId,
          oldMetId: this.oldMetId,
          setJson: this.oldConfigJson,
        })
      }
    },
    // 收款对接渠道1下拉框
    changePayChannel(val) {
      this.form.payMethodId = ''
      this.form.configJson = ''
      this.payChannelList.find((item) => {
        if (item.payChannelId == val) {
          this.payMethodList = item.payMethodEchoSourceDtos
        }
      })
      this.form.payMethodId = this.payMethodList[0].payMethodId
      this.changePayMethod()
    },
    //获取收款渠道列表
    async getPayChannel(val) {
      await finOrder.getPayChannel().then((res) => {
        this.payChannelList = res.data
      })
      if (val) {
        this.payChannelList.find((item) => {
          if (item.payChannelId == val) {
            this.payMethodList = item.payMethodEchoSourceDtos
          }
        })
      }
    },
    //复制
    copy(val) {
      const copyEle = document.getElementById('testCopy') // 获取要复制的节点
      const range = document.createRange() // 创造range
      window.getSelection().removeAllRanges() //清除页面中已有的selection
      range.selectNode(copyEle) // 选中需要复制的节点
      window.getSelection().addRange(range) // 执行选中元素
      const copyStatus = document.execCommand('Copy') // 执行copy操作
      // 对成功与否定进行提示
      if (copyStatus) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败')
      }
      window.getSelection().removeAllRanges() //清除页面中已有的selection
    },
    //测试下单
    test() {
      finOrder
        .testDoPay({
          ...this.form,
        })
        .then((res) => {
          this.testVisible = true
          this.successMessageDetail = res.data
          this.show = true
          // console.log('testDoPayresuccess', res)
        })
        .catch((res) => {
          this.testVisible = true
          // this.$message.destroy()
          this.show = false
          this.msg = res.msg
          this.errorMessageDetail = res.data
          // console.log('testDoPayreserror', res)
        })
    },
    confirm() {
      this.testVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
.card {
  margin: 20px;
  height: 100%;
}

.save {
  width: 100px;
}
.paralleling {
  position: absolute;
}
.test {
  width: 100px;
  margin-left: 20px;
}
.title1 {
  font-size: 16px;
  margin-top: 5px;
  margin-left: 10px;
  font-weight: 550;
}
.title2 {
  margin-top: 20px !important;
  margin-left: 30px !important;
}

.show {
  color: #fff;
  background-color: #fff;
}
::v-deep .ant-form-item-label > label {
  font-weight: 550;
  font-size: 14px;
}
.ant-form {
  margin-top: 50px;
}
.img {
  width: 20px !important;
  margin-bottom: 3px;
}
::v-deep .ant-form-item {
  margin-bottom: 10px;
}
::v-deep .configJson {
  margin-top: 2px;
}

// #testCopy {
// }
.testCopy {
  color: #fff;
  width: 20px;
  height: 20px;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}

::v-ddep .ant-modal-footer {
  border-top: 1px solid #fff;
}
</style>
